import { create } from "zustand";

interface NotificationBarState {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

export const useNotificationBarState = create<NotificationBarState>(
  (set) => ({
    isVisible: false,
    setIsVisible: (isVisible: boolean) => set({ isVisible }),
  })
);
